<!-- <template>
	<div>
		<p v-if="!token">Verifica del login in corso...</p>
		<p v-else>Benvenuto! Stai per essere reindirizzato alla dashboard...</p>
	</div>
</template>

<script>
	import { setAuth } from "@/router";
	export default {
		name: "OAuthSuccess",
		beforeRouteEnter(to, from, next) {
			const token = to.query.token;

			if (token) {
				localStorage.setItem("authToken", token);
				setAuth(true);
				next((vm) => {
					vm.$router.replace({ name: "Dashboard" });
				});
			} else {
				next({ name: "Auth" });
			}
		},
	};
</script> -->

<template>
	<!-- ===== background full-viewport ===== -->
	<div
		class="min-h-screen bg-no-repeat bg-center md:bg-right bg-cover relative flex items-center justify-start px-6"
		:style="{ backgroundImage: `url(${bg})` }"
	>
		<!-- overlay -->
		<div class="absolute inset-0 bg-black/60"></div>

		<!-- ===== messaggio “card” ===== -->
		<div class="relative z-10 w-full max-w-sm mx-auto space-y-4 p-8 rounded shadow bg-white/10 backdrop-blur text-center">
			<p
				v-if="!ready"
				class="text-white"
			>
				Verifica dell’account in corso…
			</p>

			<p
				v-else
				class="text-white"
			>
				Benvenuto {{ user }}!<br />
				Verrai reindirizzato alla dashboard tra pochi secondi…
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import axios from "@/axiosInstance";
	import { setAuth } from "@/router";
	import { onMounted, ref } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import { useToast } from "vue-toast-notification";

	import bg from "@/assets/sfondo-bg-1.png"; // immagine

	const router = useRouter();
	const route = useRoute();
	const toast = useToast();

	const ready = ref(false);
	const user = ref("");

	onMounted(async () => {
		/* ①  prendo i dati utente (se il cookie è già valido) */
		try {
			const { data } = await axios.get("/auth/me", { withCredentials: true });
			user.value = data.username || data.email || "";
			setAuth(true);
			// toast.success(`Bentornato ${data.username || data.email}! Accesso con GitHub riuscito.`, { duration: 4000, position: "top-right" });
			ready.value = true;
		} catch (err) {
			console.error(err);
			ready.value = true;
			toast.error("Sessione non valida, per favore effettua di nuovo il login");
			setTimeout(() => router.replace({ name: "Auth" }), 2500);
		}

		/* ②  breve attesa e redirect */
		// setTimeout(() => router.replace({ name: "Dashboard" }), 3000); // 2 s

		// Mantieni il flag  ?auth=provider
		setTimeout(() => {
			router.replace({
				name: "Dashboard",
				query: { auth: route.query.auth }, // 👈  preserva il provider
			});
		}, 3000);
	});
</script>
